class IndicatorUtility

  @STATUS =
    missing:
      label: 'Missing'
      background: 'bg-red'
      icon: 'far fa-question-circle'
    unknown:
      label: 'Unknown'
      background: 'bg-grey'
      icon: 'far fa-question-circle'
    unconfirmed:
      label: 'Unconfirmed'
      background: 'bg-orange'
      icon: 'far fa-question-circle'
    unavailable:
      label: 'Unavailable'
      background: 'bg-recess'
      icon: 'far fa-times-circle'
    available:
      label: 'Available'
      background: 'bg-green'
      icon: 'far fa-check-circle'

  @ICONS =
    omni_local: 'fal fa-share-alt'
    national_omnichannel: 'fal fa-share-alt'
    category_package: 'fal fa-box'
    shipping_area: 'fal fa-shipping-fast'
    signage: 'fal fa-copy'
    website: 'fal fa-link'
    dates_confirmed: 'fal fa-calendar-check'
    cold_storage: 'fal fa-wind'
    frozen_storage: 'fal fa-snowflake'
    sampling_asset: 'fal fa-gifts'
    onsite_asset: 'fal fa-store'
    pallet_delivery: 'fal fa-pallet'
    printer: 'fal fa-print'
    pullup_banner: 'fal fa-sign'
    social_boost: 'fal fa-arrow-alt-circle-up'
    min_payout: 'fal fa-dollar-sign'

  @statusFor: (indicator) ->
    @STATUS[indicator.status]

  @iconFor: (indicator) ->
    @ICONS[indicator.indicator_key]

  @routeFor: (indicator) ->
    { indicator_key } = indicator

    name = null
    params = {}
    query = {}

    if ['omni_local', 'category_package', 'sampling_asset', 'onsite_asset'].includes indicator_key
      name = 'AudienceCreativeEditPage'
      params = { audienceCreativeId: indicator.creative_id }
      query = { step: 'inventory' }

    if ['shipping_area', 'physical_signs', 'cold_storage', 'frozen_storage', 'pallet_delivery', 'printer', 'pullup_banner'].includes indicator_key
      name = 'VenueEditPage'
      params = { venueId: indicator.parent_id }
      query = { step: 'location' }

    if ['dates_confirmed', 'social_boost'].includes indicator_key
      name = 'AudienceCreativeEditPage'
      params = { audienceCreativeId: indicator.creative_id }
      query = { step: 'availability' }

    if ['website', 'national_omnichannel'].includes indicator_key
      name = 'SupplierEditPage'
      params = { supplierId: indicator.top_org_id }

    if ['min_payout'].includes indicator_key
      name = 'OrganizerEditPage'
      params = { organizerId: indicator.parent_id }

    { name, params, query }

export default IndicatorUtility
